import { useState, useEffect } from 'react';
// import { lootboxData } from '../mockData';
// import LoadingScreen from './LoadingScreen';

const Lootbox = () => {
  // const [boxes, setBoxes] = useState([]);
  // const [minting, setMinting] = useState(false);
  // const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       // Simulate API latency  
  //       await new Promise(resolve => setTimeout(resolve, 1000));

  //       // Simulate API call  
  //       setBoxes(lootboxData);

  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  // if (loading) {
  //   return <LoadingScreen />;
  // }


  // const handleMint = async (boxId) => {
  //   setMinting(true);
  //   try {
  //     // Minting logic here  
  //   } catch (error) {
  //     console.error('Minting failed:', error);
  //   } finally {
  //     setMinting(false);
  //   }
  // };

  return (
    <div className="p-4">
      <h1 className="section-title mb-2">Lootbox Minting</h1>

      <div className="bg- fixed top-0 left-0 w-full h-full flex items-center justify-center backdrop-grayscale-[0.9] backdrop-blur-[2px]">
        <div className="text-2xl uppercase font-bold">Coming Soon...</div>
      </div>

      {/* <div className="grid grid-cols-2 gap-4">
        {boxes.map((box) => (
          <div
            key={box.id}
            className="rounded-lg shadow p-2"
          >
            <div className="relative">
              <img
                src={box.image}
                alt={box.name}
                className="w-full h-40 object-cover rounded-lg shadow-[0px_0px_25px_0px_rgba(255,46,255,0.9)] border-2 border-[#ffffff82]"
              />
              {box.rarity && (
                <span className="absolute uppercase top-0 right-0 bg-purple-500 text-white px-2 font-bold rounded-bl-md rounded-tr-md text-xs">
                  {box.rarity}
                </span>
              )}
              <div className=" absolute bottom-0 w-full flex justify-center">
                <h3 className="font-semibold text-center bg-[#222222] p-1 rounded-t-lg border-2 text-sm border-[#ffffff82]">{box.name}</h3>
              </div>
            </div>
            <div className="flex justify-between flex-col items-center w-full p-1">
              <button
                onClick={() => handleMint(box.id)}
                disabled={minting}
                className="bg-[#ff00c2] border-2 text-white px-2 py-1 rounded-lg disabled:opacity-50 uppercase w-full leading-none font-bold text-sm"
              >
                {minting ? 'Minting...' : 'Mint Now'}
                <div className="font-medium text-[.7rem]">({box.price})</div>
              </button>
            </div>

            <p className="text-sm text-gray-600 mb-2">{box.description}</p>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default Lootbox; 